"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var moment = require('moment');

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var isUndefined = require('lodash/isUndefined');

var ShineProducts = require('../products/ShineProducts');

var Address = require('../orders/classes/Address');

var OrderNote = require('../orders/classes/OrderNote');
/**
 * @class
 */


var Shipment = /*#__PURE__*/function () {
  function Shipment() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Shipment);

    this.id = params.id;
    this.shipping_address = params.shipping_address ? new Address(params.shipping_address) : null;
    this.date_created = params.date_created ? moment(params.date_created).toISOString() : moment().toISOString();
    this.order_id = params.order_id || '';
    this.designation = params.designation || '';
    this.status = params.status || 'proofing';
    this.archived = parseBoolean(params.archived);
    this.products = params.products && Array.isArray(params.products) ? params.products.map(function (prod) {
      return ShineProducts.instance().make(prod);
    }) : [];
    this.ship_by_date = params.ship_by_date || null;
    this.customer_ship_by_date = params.customer_ship_by_date || params.ship_by_date || null;
    this.ship_date = params.ship_date || null;
    this.shipper_id = params.shipper_id || null;
    this.shipping_type = params.shipping_type || {};
    this.origin = params.origin || null;
    this.service = params.service || null;
    this.name = params.name || 'No Name';
    this.email = (params.email || '').trim().toLowerCase();
    this.is_reprint = parseBoolean(params.is_reprint);
    this.needs_assembly = parseBoolean(params.needs_assembly);
    this.adhesive_location = params.adhesive_location || null;
    this.show_to_customer = isUndefined(params.show_to_customer) ? true : params.show_to_customer;
    this.notes = params.notes && Array.isArray(params.notes) ? params.notes.map(function (note) {
      return new OrderNote(note);
    }) : [];
  }

  _createClass(Shipment, [{
    key: "has_vellum_jackets",
    get: function get() {
      for (var i = 0; i < this.products.length; i++) {
        var product = this.products[i];

        if (product.components.some(function (c) {
          return c.component_type === 'VellumJacket';
        })) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "shipment_id",
    get: function get() {
      return this.id;
    },
    set: function set(id) {
      this.id = id;
    }
  }, {
    key: "has_samples",
    get: function get() {
      for (var i = 0; i < this.products.length; i++) {
        var product = this.products[i];

        if (product.product_type.match(/sample/)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "weight",
    get: function get() {
      return this.products.map(function (product) {
        return product.weight;
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
    }
  }, {
    key: "lastname",
    get: function get() {
      return this.shipping_address.lastname;
    }
  }, {
    key: "firstname",
    get: function get() {
      return this.shipping_address.firstname;
    }
  }, {
    key: "customer_name",
    get: function get() {
      return this.name;
    }
  }, {
    key: "telephone",
    get: function get() {
      return this.shipping_address.telephone;
    }
  }, {
    key: "address1",
    get: function get() {
      return this.shipping_address.address1;
    }
  }, {
    key: "address2",
    get: function get() {
      return this.shipping_address.address2;
    }
  }, {
    key: "zip",
    get: function get() {
      return this.shipping_address.zip;
    }
  }, {
    key: "country",
    get: function get() {
      return this.shipping_address.country;
    }
  }, {
    key: "city",
    get: function get() {
      return this.shipping_address.city;
    }
  }, {
    key: "state",
    get: function get() {
      return this.shipping_address.state;
    }
  }, {
    key: "is_canadian",
    get: function get() {
      return this.country === 'CA';
    }
  }, {
    key: "is_international",
    get: function get() {
      return this.country !== 'US';
    }
  }]);

  return Shipment;
}();

module.exports = Shipment;